import Header from '@components/header';
import { Modals } from '@components/modals/modal.comp';
import type { StudioUser } from '@stratumn/studio-shared';
import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { queryClient } from '@/lib/query-client';
import AccountService from '@/services/account/account.service';

type ContextType = { user: StudioUser; loadingUser: boolean };

export const Layout = () => {
  const [user, setUser] = useState<Maybe<StudioUser>>();
  const [loadingUser, setLoadingUser] = useState(true);
  // get routeusing react router , if route is settings, then show subheader

  useEffect(() => {
    const loadUser = async (): Promise<void> => {
      const user: Maybe<StudioUser> = await AccountService.getMe();
      setUser(user);
      setLoadingUser(false);
    };

    void loadUser();
  }, []);

  if (!user) {
    return <></>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <section className="flex h-screen w-screen flex-col overflow-hidden">
        {user && <Header user={user} />}
        <section className="relative flex min-h-0 flex-1 flex-col bg-[#fafafa]">
          <Modals />
          <Outlet context={{ user, loadingUser }} />
        </section>
      </section>
    </QueryClientProvider>
  );
};

export function useUser() {
  return useOutletContext<ContextType>();
}

export default Layout;
